/** Sync PHPLive visitor prefill for direct chat links (reads window.phplive_v in livechat_direct_link.js). */

type PhpliveWindow = Window & { phplive_v?: { name: string; email: string } };

function clearPhpliveVisitor(w: PhpliveWindow): void {
  // SSR injects `var phplive_v=…` — that global is non-configurable, so `delete` throws in strict mode
  // and used to abort logout before location.assign (preview-proxy stayed on /my-account/*).
  try {
    delete w.phplive_v;
    return;
  } catch {
    // fall through
  }
  try {
    w.phplive_v = { name: '', email: '' };
  } catch {
    // ignore
  }
}

export function syncPhpliveVisitorPrefill(auth: {
  login?: string;
  name?: string;
  customer_email?: string;
  email?: string;
} | null): void {
  if (typeof window === 'undefined') return;
  const w = window as PhpliveWindow;
  if (!auth) {
    clearPhpliveVisitor(w);
    return;
  }
  const name = String(auth.name ?? auth.login ?? '').trim();
  const email = String(auth.customer_email ?? auth.email ?? '').trim();
  if (!name && !email) {
    clearPhpliveVisitor(w);
    return;
  }
  try {
    w.phplive_v = { name, email };
  } catch {
    // ignore non-writable globals
  }
}
